import { toast } from 'components/ui/toast-store'

/**
 * What the server said about a deck made from, or saved as, a deck template
 * (MYD-604): each warning as its own toast, and a count of blocks left out.
 * Warnings persist until dismissed, because each names something missing
 * from the result the user is about to look at.
 */
export const announceTemplateNotices = ({ warnings = [], dropped = 0 }: { warnings?: string[]; dropped?: number }, droppedMessage: (count: number) => string) => {
	for (const warning of warnings) toast.warning(warning)
	if (dropped > 0) toast.info(droppedMessage(dropped))
}

const blocks = (count: number) => (count === 1 ? '1 block' : `${count} blocks`)

/** For a deck made from a template: blocks the user may not see. */
export const droppedFromDeck = (count: number) => `${blocks(count)} left out that your account cannot see, such as financials.`

/** For a deck saved as a template: blocks that could not apply to their section's kind of asset. */
export const droppedFromTemplate = (count: number) => `${blocks(count)} left out of the template: they cannot show that kind of asset.`
